module.exports = __webpack_public_path__ + "images/marketing/peeps/liz_falvo.jpg";